window.addEventListener('scroll', () => this.scrollHandler());


function scrollHandler() {
    var AnnouncementBar = document.querySelector('.phone-bar');
    var siteHeader = document.querySelector('#SiteHeader');
    //console.log("AnnouncementBar: ", AnnouncementBar);
    if (window.scrollY >= 250) {
        //debugger;
        siteHeader.classList.add("site-header--stuck");
        AnnouncementBar.classList.add('site-announcment--stuck');
    } else {
        siteHeader.classList.remove("site-header--stuck");
        AnnouncementBar.classList.remove('site-announcment--stuck');
    }
}